module.exports = __webpack_public_path__ + "static/media/deleteHover.2c752a24.svg";